import { call, select } from 'redux-saga/effects';
import { getMobileInsurance as getMobileInsuranceBit } from '../bitSagas/getMobileInsurance';
import { commonActions } from '../reducers/common';
import { FLOW_TYPES } from '../flowDefinition/flowTypes';

const offerStore = state => state.offer;
const flowStore = state => state.flow;

export function* getMobileInsurance(params) {
  const offer = yield select(offerStore);
  const { flowJson } = yield select(flowStore);

  const { normalizeHttpErrors, showError } = params;
  const {
    productOffering, poR, storageId: storage, insurance,
  } = offer;
  let productOfferingToBuy = productOffering;
  if (flowJson.flowName === FLOW_TYPES.PACK) {
    productOfferingToBuy = poR;
  }
  const insuranceParams = {
    productOffering: productOfferingToBuy,
    storage,
    insurance,
    reduxUpdate: {
      successUpdate: commonActions.setMobileInsurance,
      errorUpdate: showError,
    },
    normalizeHttpErrors,
  };
  yield call(getMobileInsuranceBit, insuranceParams);

  return null;
}
